<script setup>
import GuidanceComponent from "../../layouts/components/Notice.vue";
import HeadlineComponent from "../../form/components/Headline.vue";
import {inject, ref} from 'vue';
const SHIRONEKO_PROJECT = inject('SHIRONEKO_PROJECT');
const MAGICIANWIZ = inject('MAGICIANWIZ');
const props = defineProps({
    code: String,
});
function getMessage() {
    switch(props.code) {
        // 白猫PJの場合
        case SHIRONEKO_PROJECT:
            return "<span style='color: red;'>本フォームを利用する等して、他者のアカウント情報を入手する行為は、不正アクセス禁止法等の法令に抵触することがございます。\n" +
                "\n" +
                "法的責任を問われる場合もございますため、上記行為を行うことがないようお願い申し上げます。\n</span>" +
                "\n" +
                "1. アカウント復旧は、ご本人さまであることの確認が取れた場合にのみ実施させていただきます。ご本人さま確認が取れなかった場合、復旧はお断りしております。\n" +
                "\n" +
                "2. 本フォームからご連絡いただいた後、ご本人さま確認に必要な情報が不足している場合は、再度情報のご入力をお願いすることがございます。\n" +
                "\n" +
                "3. アカウントのログインに必要な情報は、お客さまにて管理いただいております。運営チームにてアカウント復旧をした場合でも、ログインできなかった期間の補填等はお断りしております。\n" +
                "\n" +
                "4. ゲーム内のメニューより、アカウント自体の削除を行っている場合、アカウントを復旧することはできません。\n" +
                "\n" +
                "5. 本フォームでは「アカウント復旧の依頼」のみを受け付けております。ご質問やご意見等へのご案内は差し上げてしておりませんので、別途ご用意しております専用の窓口からご連絡ください。\n" +
                "\n" +
                "6. 本フォームを通じて取得した個人情報等を、当社が別途定める「<a href='https://colopl.co.jp/app/privacypolicy/shironekoproject/ja_i.html'>プライバシーポリシー</a>」に基づき、適切に取り扱うものとします。";
        
        // 黒猫のウィズの場合
        case MAGICIANWIZ:
            return "<span style='color: red;'>本フォームを利用する等して、他者のアカウント情報を入手する行為は、不正アクセス禁止法等の法令に抵触することがございます。\n" +
                "\n" +
                "法的責任を問われる場合もございますため、上記行為を行うことがないようお願い申し上げます。\n</span>" +
                "\n" +
                "1. アカウント復旧は、ご本人さまであることの確認が取れた場合にのみ実施させていただきます。ご本人さま確認が取れなかった場合、復旧はお断りしております。\n" +
                "\n" +
                "2. 本フォームからご連絡いただいた後、ご本人さま確認に必要な情報が不足している場合は、再度情報のご入力をお願いすることがございます。\n" +
                "\n" +
                "3. アカウントのログインに必要な情報は、お客さまにて管理いただいております。運営チームにてアカウント復旧をした場合でも、ログインできなかった期間の補填等はお断りしております。\n" +
                "\n" +
                "4. ゲーム内のメニューより、アカウント自体の削除を行っている場合、アカウントを復旧することはできません。\n" +
                "\n" +
                "5. 本フォームでは「アカウント復旧の依頼」のみを受け付けております。ご質問やご意見等へのご案内は差し上げてしておりませんので、別途ご用意しております専用の窓口からご連絡ください。\n" +
                "\n" +
                "6. 本フォームを通じて取得した個人情報等を、当社が別途定める「<a href='https://colopl.co.jp/app/privacypolicy/magicianwiz/ja_i.html'>プライバシーポリシー</a>」に基づき、適切に取り扱うものとします。";
    }
    return '';
}
const consent = ref(false);
const guidance = ref(null);

function checkScrollable() {
    const element = guidance.value;
    if (!guidance.value) {
        return;
    }
    // 要素の高さ < スクロール可能な全体の高さの場合、スクロールが発生する
    if (element.offsetHeight < element.scrollHeight) {
        return true;
    } else {
        return false;
    }
}

</script>

<template>
    <div class="uk-margin-small-left uk-margin-small-right uk-flex-1">
        <div class="uk-flex uk-flex-column uk-height-1-1">
            <headline-component :title="'復旧手続きにおける同意事項'"/>
            <div ref="guidance" id="guidance-wrapper" class="uk-flex-1 uk-margin uk-background-muted"  :class="{'scrollable': checkScrollable()}">
                <guidance-component :background-color="false" :message="getMessage()"/>
            </div>
            <div class="uk-card uk-card-default uk-margin-small uk-text-left uk-padding-small" @click="consent = !consent" style="cursor: pointer;">
                <input type="checkbox" class="uk-checkbox" name="consent" :checked="consent"/> 同意する
            </div>
            <div class="uk-margin uk-text-center">
                <router-link to="/form/1">
                    <button class="uk-button uk-button-primary uk-border-rounded uk-margin-auto uk-width-auto" :disabled="!consent">進む</button>
                </router-link>
            </div>

        </div>
    </div>
</template>

<style scoped>
#guidance-wrapper {
    overflow-y: auto;
    .guidance {
        padding: 20px;
        white-space: pre-wrap;
        text-align: left !important;
    }
    /* 強制的にスクロールバーを表示させる */
    &.scrollable {
        &::-webkit-scrollbar {
            width: 10px;
        }

        &::-webkit-scrollbar-track {
            border-radius: 10px;
            box-shadow: inset 0 0 5px rgba(0, 0, 0, .1);
        }

        &::-webkit-scrollbar-thumb {
            background-color: rgba(0, 0, 50, .5);
            border-radius: 10px;
            box-shadow: 0 0 0 1px rgba(255, 255, 255, .3);
        }
        box-shadow: inset 0em -0.9em 0.8em -0.5em;

        /* 最下部までスクロールされた際、この要素が影の上に重ねて表示されることで、影が消えたように見える */
        &::after {
            content: '';
            display: block;
            position: relative;
            z-index: 1000;
            height: 0.8em;
            background-color: #f8f8f8;
        }
    }
}
</style>